/* eslint-disable camelcase */
import assign from "lodash/fp/assign";
import first from "lodash/fp/first";
import isNil from "lodash/fp/isNil";
import topupDialog from "./dialog/dialog.html";
import topupController from "./dialog/dialog.controller";
import chargeDialog from "./chargeDialog/chargeDialog.html";
import chargeController from "./chargeDialog/chargeDialog.controller";
import resetPasswordController from "./resetPasswordDialog/resetPasswordDialog.controller";
import resetPassword from "./resetPasswordDialog/resetPasswordDialog.html";
import constants from "../../core/constants";
import { getUriHash } from "../../core/utils";
import callDialog from "./callDialog/callDialog.html";
import callController from "./callDialog/callDialog.controller";

class Controller {
  constructor(
    $injector,
    $scope,
    $state,
    $stateParams,
    $mdDialog,
    $window,
    $timeout,
    PureCloud
  ) {
    "ngInject";

    this.$state = $state;
    this.$mdDialog = $mdDialog;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$window = $window;
    this.User = $injector.get("User");
    this.Role = $injector.get("Role");
    this.Topup = $injector.get("Topup");
    this.Events = $injector.get("Events");
    this.Lists = $injector.get("Lists");
    this.Bookings = $injector.get("Bookings");
    this.Messages = $injector.get("Messages");
    this.ActionLists = $injector.get("ActionLists");
    this.TopupsTransforms = $injector.get("TopupsTransforms");
    this.CustomerTransforms = $injector.get("CustomerTransforms");
    this.BookingsTransforms = $injector.get("BookingsTransforms");
    this.sections = $injector.get("Sections").customersSections;

    this.topupsFields = this.TopupsTransforms.fields;
    this.defaultRoles = this.Lists.all.roles;
    this.defaultCorpRoles = this.Lists.all.corpRoles;
    this.topupFields = this.CustomerTransforms.fields;
    this.bookingFields = this.BookingsTransforms.fields;
    this.customerResourceId = this.$stateParams.id;
    this.transactionsFields = this.CustomerTransforms.customerTransactionFields;
    this.transactionResourceActions = this.ActionLists.all.customerTransactionActions;

    this.updateCustomerEvent = this.Events.eventsType.onUpdateCustomer;
    this.noteEvent = this.Events.getUpdateEvent("customerNote");
    this.updateCustomerCorpEvent = this.Events.getUpdateEvent("customerCorp");
    this.updateCustomerCityEvent = this.Events.getUpdateEvent("customerCity");
    this.updateCustomerCorpRoleEvent = this.Events.getUpdateEvent(
      "customerCorpRole"
    );
    this.bookingParams = { user: this.$stateParams.id, isCityRequired: false };
    this.pressEditRole = this.Events.getUpdateEvent("pressEditRole");
    this.tokenCopied = false;
    this.params = {};

    // PureCloud Config
    this.pureCloudSDK = PureCloud;
    this.pureCloudClientId = "";
    this.pureCloudRedirectUri = "";
    this.pureCloudState = "";
    this.callState = "";
    this.bookingActions = [
      { title: "Go to package", method: this.goToPackage.bind(this) },
    ];
  }

  $onInit() {
    const navigateEvent = this.Events.eventsType.onNavigate;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;

    const onNavigate = (options) =>
      this.$state.transitionTo(options.state, { id: options.id }, true);
    const onUpdateCustomer = (options) => {
      let request;
      const params = {};
      params[options.key] = options.value;
      if (options.key === "phone") {
        params[options.key] = options.value.toString();
      }

      if (options.methodName) {
        if (options.method === "put") {
          request = this.User.updateActionPutMethod(
            this.$stateParams.id,
            options.methodName,
            params
          ).$promise;
        } else {
          request = this.User.updateAction(
            this.$stateParams.id,
            options.methodName,
            params
          ).$promise;
        }
      } else {
        request = this.User.update(this.$stateParams.id, params).$promise;
      }
      request.then(
        (response) => {
          this.customer = this.CustomerTransforms.justify(response);
          this.Events.emit(
            this.successNotificationEvent,
            this.Messages.updateMessage("customer", options.key)
          );
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };

    const onNoteUpdate = (note) => {
      const comment = note.comment.value;

      this.User.addNote(this.$stateParams.id, { comment }).$promise.then(
        (response) => {
          this.Events.emit(
            this.successNotificationEvent,
            this.Messages.addMessage("note")
          );
          this.notes[note.index] = first(
            this.CustomerTransforms.justifyNotes([response])
          );
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };

    this.handleBlock = () => {
      const isActive = this.customer.active.value;
      const message = isActive ? "block" : "unblock";
      const confirm = this.$mdDialog
        .confirm()
        .title(
          `Are you sure you want to ${message} "${this.customer.name.value}"?`
        )
        .ok(message)
        .cancel("Cancel");

      this.$mdDialog.show(confirm).then(
        () => {
          const active = !this.customer.active.value;
          const methodName = active ? "unblock" : "block";

          this.User.updateAction(
            this.$stateParams.id,
            methodName
          ).$promise.then(
            (response) => {
              this.customer = this.CustomerTransforms.justify(response);
              this.Events.emit(
                this.successNotificationEvent,
                this.Messages.enableMessage("customer", message)
              );
            },
            (response) =>
              this.Events.emit(this.errorNotificationEvent, response.data)
          );
        },
        () => {}
      );
    };

    const onCorporateUpdate = (options) => {
      const params = {};
      params[options.key] = options.name ? options.name._id : null;

      this.User.setCorporate(this.$stateParams.id, params).$promise.then(
        (response) => {
          this.customer = this.CustomerTransforms.justify(response);
          this.Events.emit(
            this.successNotificationEvent,
            this.Messages.updateMessage("customer", "corporate")
          );
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };

    const onCorporateRoleUpdate = (options) => {
      const params = {};
      params[options.key] = options.value;

      if (isNil(this.customer.corporate)) {
        this.Events.emit(this.errorNotificationEvent, {
          message: "Error: add corporate first!",
        });
        this.customer.corpRole = "";
        return 0;
      }

      this.User.setCorpRole(this.$stateParams.id, params).$promise.then(
        (response) => {
          this.customer = this.CustomerTransforms.justify(response);
          this.Events.emit(
            this.successNotificationEvent,
            this.Messages.updateMessage("customer", "corporate role")
          );
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };

    const onCityUpdate = (options) => {
      const params = {};
      params[options.key] = options.name._id;
      this.User.updateCity(this.$stateParams.id, params).$promise.then(
        (response) => {
          this.customer = this.CustomerTransforms.justify(response);
          this.Events.emit(this.successNotificationEvent, {
            message: "City is updated successfully ",
          });
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      );
    };
    const fetchRoles = () => {
      this.Role.getAll().$promise.then((response) => {
        this.availableRoles = response.data;
      });
    };
    this.User.get(this.$stateParams.id).$promise.then(
      (response) => {
        this.customer = this.CustomerTransforms.justify(response);
        // Profile type
        this.isBusinessProfile = this.customer.type.value === "BusinessUser";
        fetchRoles();
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.User.notes({ user: this.$stateParams.id }).$promise.then(
      (response) => {
        this.notes = this.CustomerTransforms.justifyNotes(response.hits);
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.Topup.getAll({
      user: this.$stateParams.id,
      isCityRequired: false,
    }).$promise.then(
      (response) => {
        this.topups = this.TopupsTransforms.justify(response.hits);
        this.topupsTotal = response.total;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );

    this.showTopup = () => {
      const customerName = this.customer.name.value;
      const topup = this.$mdDialog.show({
        controller: topupController,
        controllerAs: "$ctrl",
        template: topupDialog,
        locals: {
          customer: this.customer,
        },
      });

      topup.then(
        (obj) => {
          const params = assign(obj, {
            amount: obj.amount * constants.currencyBy,
          });
          const methodName =
            obj.type === "compensation" ? "compensate" : "topup";

          this.User.updateAction(
            this.$stateParams.id,
            methodName,
            params
          ).$promise.then(
            (response) => {
              this.topups.push(this.TopupsTransforms.justifyObj(response));
              this.Events.emit(this.successNotificationEvent, {
                message: `You topuped ${customerName} successfully.`,
              });
            },
            (response) =>
              this.Events.emit(this.errorNotificationEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.showCharge = () => {
      const customerName = this.customer.name.value;
      const charge = this.$mdDialog.show({
        controller: chargeController,
        controllerAs: "$ctrl",
        template: chargeDialog,
        locals: {
          customer: this.customer,
        },
      });

      charge.then(
        (obj) => {
          const payload = assign(obj, {
            amount: obj.amount * constants.currencyBy,
            currency: obj.currency,
          });
          this.User.charge(this.$stateParams.id, payload).$promise.then(
            () => {
              this.Events.emit(this.successNotificationEvent, {
                message: `You charged ${customerName} successfully.`,
              });
            },
            (response) =>
              this.Events.emit(this.errorNotificationEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.resetPassword = () => {
      const resetPass = this.$mdDialog.show({
        controller: resetPasswordController,
        controllerAs: "$ctrl",
        template: resetPassword,
        locals: {
          customer: this.customer,
        },
      });

      resetPass.then(
        (method) => {
          this.User.resetPassword({
            id: this.customer._id.value,
            method: method.geteway,
          }).$promise.then(
            (response) => {
              const customer = this.customer;

              this.Events.emit(this.successNotificationEvent, {
                message: "Done successfully.",
              });
              customer.preferences = { ...customer.preferences, ...response };
              this.customer = this.CustomerTransforms.justify(customer);
            },
            (response) =>
              this.Events.emit(this.errorNotificationEvent, response.data)
          );
        },
        () => {}
      );
    };

    this.onSuccess = () => {
      this.tokenCopied = true;

      this.$timeout(() => {
        this.tokenCopied = false;
      }, 2000);
    };

    this.Events.on(navigateEvent, onNavigate);
    this.Events.on(this.updateCustomerEvent, onUpdateCustomer);
    this.Events.on(this.updateCustomerCityEvent, onCityUpdate);
    this.Events.on(this.pressEditRole, fetchRoles);
    this.Events.on(this.noteEvent, onNoteUpdate);
    this.Events.on(this.updateCustomerCorpEvent, onCorporateUpdate);
    this.Events.on(this.updateCustomerCorpRoleEvent, onCorporateRoleUpdate);

    // PureCloud Config
    this.pureCloudClientId = constants.pureCloudClientId;
    this.pureCloudClientRedirectUri = `${location.origin}${constants.pureCloudClientRedirectUri}`;
    this.pureCloudState = `customer-${this.customerResourceId}`;
    let params = {};
    if (window.location.hash) {
      params = getUriHash(params);
      this.purecloudToken = params.purecloud_token;
      setTimeout(() => {
        this.Events.emit(this.successNotificationEvent, {
          message: "Authentication .. Done",
        });
      }, 1500);
    }
  }

  goToPackage(row) {
    const { commuter_package_subscription } = row;

    if (commuter_package_subscription) {
      this.$state.transitionTo(`package`, {
        id: commuter_package_subscription,
      });
    } else {
      this.Events.emit(this.errorNotificationEvent, {
        message: "This booking does not have any active package",
      });
    }
  }

  getWhitelistedStatus(hasBusinessProfile) {
    if (hasBusinessProfile && hasBusinessProfile.value) {
      return "Employee At/Whitelisted";
    }
    return "Employee At";
  }
  // Show Call Dialog
  showCall() {
    if (this.pureCloudAccessTokenExists()) {
      this.$mdDialog.show({
        controller: callController,
        controllerAs: "$ctrl",
        template: callDialog,
        locals: {
          customer: this.customer,
          callState: this.callState,
          Events: this.Events,
        },
      });
    }
  }

  onStartCall() {
    try {
      let phoneToBeCalled = "";
      // Start authentication
      this.pureCloudSDK.authenticate(
        this.pureCloudClientRedirectUri,
        this.pureCloudClientId,
        this.pureCloudState
      );

      // Start Api Call
      // adding prefix to phone number agreed on with purecloud
      switch (this.customer.phone_data.region_code) {
        case "EG":
          phoneToBeCalled = `80${this.customer.phone_data.national_number}`;
          break;
        default:
          phoneToBeCalled = `500${this.customer.phone_data.country_code}${this.customer.phone_data.national_number}`;
          break;
      }
      const response = this.pureCloudSDK.postCall(phoneToBeCalled);

      response
        .then(() => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Call placed for this participant",
          });
        })
        .catch((err) => {
          this.Events.emit(this.errorNotificationEvent, {
            message: `${err.status}, Error in placing this call`,
          });
          this.$mdDialog.cancel();
        });
    } catch (err) {
      this.Events.emit(this.errorNotificationEvent, {
        message: "Error in placing this call",
      });
      callController.close();
      this.$mdDialog.cancel();
    }
  }

  onAuthorize() {
    try {
      // Start authentication
      this.pureCloudSDK.authenticate(
        this.pureCloudClientRedirectUri,
        this.pureCloudClientId,
        this.pureCloudState
      );
    } catch (err) {
      this.Events.emit(
        this.errorNotificationEvent,
        "Error in authorizing purecloud agent"
      );
    }
  }

  pureCloudAccessTokenExists() {
    if (window.location.hash) return true;
    return false;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/customer/customer.controller.js